
/**
 * gql请求方法
 */

export function getQuery(query, variables) {
	variables = variables || {};
	return this.$apollo.query({
		query,
		variables,
		fetchPolicy:'no-cache'
	})
}
export function getMutate(mutation, variables) {
	variables = variables || {};
	return this.$apollo.mutate({
		mutation,
		variables,
		fetchPolicy:'no-cache'
	})
}

